// @flow

import { observer } from "mobx-react";
import React from "react";

import Video from "app/models/Video";

import "./TimelineWizard.scss";

type Props = {
    video: Video,
    progress: number,
    onClick: Function,
    highlight: boolean,
    disabled: boolean
};

@observer
export default class TimelineWizard extends React.Component<Props> {
    render() {
        return (
            <button
                type="button"
                className="TimelineWizard"
                disabled={this.props.disabled}
                onClick={this.props.onClick}
            >
                <i className="fa fa-plus" />

                {this.renderHighlight()}
            </button>
        );
    }

    renderHighlight() {
        if (!this.props.highlight) return null;

        return <div className="TimelineWizard__highlight">Add me</div>;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineWizard/TimelineWizard.js